import { useCallback, useEffect, useRef, useState } from 'react';
import { useMedia } from 'react-use';

import { BREAKPOINTS } from '@libs/common-next';

const INLINE_MEDIA_QUERY = `(min-width: ${BREAKPOINTS.lg}px)`;

export function useSearchOverlay(open: boolean) {
    const controlsRef = useRef<HTMLDivElement>(null);
    const formRef = useRef<HTMLFormElement>(null);
    const searchRootRef = useRef<HTMLDivElement>(null);
    const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);
    const isInline = useMedia(INLINE_MEDIA_QUERY, false);
    const isFullscreen = !isInline;

    useEffect(() => {
        if (!isFullscreen || !open) return;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [isFullscreen, open]);

    const setSearchRoot = useCallback((element: HTMLDivElement | null) => {
        searchRootRef.current = element;
        setPortalContainer(element?.closest<HTMLElement>('.header__main-section-sticky') ?? null);
    }, []);

    return { controlsRef, formRef, isFullscreen, portalContainer, searchRootRef, setSearchRoot };
}
